import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-between q-px-md q-mb-lg q-mt-md" }
const _hoisted_2 = { class: "row gap-sm col-grow k-dialog__title" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "row items-center justify-between no-wrap q-py-20" }
const _hoisted_5 = { class: "fs-13px fw-500 text-space-b-100" }
const _hoisted_6 = { class: "q-mr-xs" }
const _hoisted_7 = { class: "q-py-20 column no-wrap gap-20" }

import _ from 'lodash'
import { computed, Ref, ref, toValue } from 'vue'
import LandingListFilterItem from './LandingListFilterItem.vue'
import { IFilter, IFilterModel } from 'src/common/interfaces'

interface IProps {
  filters?: IFilter[]
  filterModel: IFilterModel
}

type Emits = { apply: [filter: IFilterData] }

export interface IFilterObj {
  label: string
  value: unknown
  key: string
}

export interface IFilterData {
  applied: IFilterObj[]
  model: IFilterModel
  [key: string]: unknown
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'LandingListFilters' },
  __name: 'LandingListFilters',
  props: /*@__PURE__*/_mergeModels({
    filters: { default: () => [] },
    filterModel: { default: () => ({}) }
  }, {
    "modelValue": { type: Boolean, default: false },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["apply"], ["update:modelValue"]),
  setup(__props: any, { expose: __expose, emit: __emit }) {


const props = __props
const emit = __emit
const dialogModel = _useModel(__props, "modelValue")

const filterRef: Ref<IFilterModel> = ref(toValue(() => props.filterModel))
const filtersRef: Ref<IFilter[]> = ref(toValue(() => props.filters))
const flatFilters = _.flatMap(filtersRef.value, (filter) => {
  if (filter.type === 'group' && filter.children) {
    const flatChildren = _.map(filter.children, (child) => {
      return { ...child, parentGroup: filter.name }
    })
    return [filter, ...flatChildren]
  } else {
    return filter
  }
})

const initialModel = { ...filterRef.value }

for (const key of Object.keys(initialModel)) {
  if (typeof initialModel[key] === 'string') initialModel[key] = ''
  else if (typeof initialModel[key] === 'boolean') initialModel[key] = false
  else if (initialModel[key] instanceof Array) initialModel[key] = []
  else initialModel[key] = undefined
}

function applyFilters() {
  const appliedFilters = getAppliedFiltersList(filterRef.value, initialModel)
  emit('apply', { model: filterRef.value, applied: appliedFilters })
}

function resetFilters() {
  for (const filter of flatFilters) {
    const key = filter?.field
    if (key) {
      if (!filter?.default) filterRef.value[key] = initialModel[key]
      else filterRef.value[key] = filter?.default
    }
  }
  applyFilters()
}

function resetFilterByKey(key: string) {
  const filter = flatFilters.find((filter) => filter.field === key)
  if (!filter?.default) filterRef.value[key] = initialModel[key]
  else filterRef.value[key] = filter?.default
  applyFilters()
}

function getAppliedFiltersList(filterValues: IFilterModel, initialValues: { [key: string]: unknown }) {
  const appliedFilters = []
  for (const key of Object.keys(filterValues)) {
    if (!_.isEqual(filterValues[key], initialValues[key])) {
      const filter = flatFilters.find((filterObj) => filterObj?.field === key)

      if (filter) {
        const appliedFilterObj = {
          key,
          value: filterValues[key],
          label: '',
        }
        if (filter.type === 'dropdown') {
          appliedFilterObj.label = filter.tag ?? ''
          if (filterValues[key] instanceof Array) {
            const selectedOptions = []
            for (const id of filterValues[key]) {
              const dropdownOption = filter.bind?.options?.find((option) => option.value === id)
              if (dropdownOption) selectedOptions.push(dropdownOption.label)
            }
            appliedFilterObj.value = selectedOptions.join(', ')
          } else {
            const selectedOption = filter.bind?.options?.find((option) => option.value === filterValues[key])
            if (selectedOption) appliedFilterObj.value = selectedOption.label
          }
        } else {
          appliedFilterObj.label = filter.tag ?? ''
        }
        appliedFilters.push(appliedFilterObj)
      }
    }
  }
  return appliedFilters
}

const appliedFiltersCount = computed(() => {
  return getAppliedFiltersList(filterRef.value, initialModel).length
})

// watch(
//   () => props.filters,
//   () => {
//     for (const filter of props.filters) {
//       if (filter?.field?.includes(',')) {
//         const keys = filter?.field?.split(',')
//         initialModel[keys[0].trim()] = filter?.default ?? ''
//         initialModel[keys[1].trim()] = filter?.default ?? ''
//       } else {
//         const key = filter?.field
//         if (!filter?.default) {
//           if (typeof initialModel[key] === 'string') initialModel[key] = ''
//           else if (typeof initialModel[key] === 'boolean')
//             initialModel[key] = false
//           else if (initialModel[key] instanceof Array) initialModel[key] = []
//           else initialModel[key] = null
//         } else initialModel[key] = filter?.default
//       }
//     }
//     console.log(initialModel)
//   },
//   { deep: true }
// )

__expose({ resetFilters, resetFilterByKey })

return (_ctx: any,_cache: any) => {
  const _component_k_icon = _resolveComponent("k-icon")!
  const _component_k_btn = _resolveComponent("k-btn")!
  const _component_k_divider = _resolveComponent("k-divider")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createBlock(_component_k_dialog, {
    modelValue: dialogModel.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogModel).value = $event)),
    position: "right",
    class: "LandingListFilters",
    "container-class": "LandingListFilters-container bg-teal-white-10 no-border-radius q-pa-md no-wrap",
    "content-class": "LandingListFilters-content"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_k_icon, {
            name: "filters",
            size: "24px",
            color: "cool-gray-70"
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "fs-15px fw-500 text-cool-gray-100" }, " Filters ", -1))
        ]),
        _createVNode(_component_k_btn, {
          size: "sm",
          label: "Apply",
          class: "LandingListFilters__apply-btn",
          onClick: applyFilters
        })
      ]),
      _createVNode(_component_k_divider, { size: "md" })
    ]),
    content: _withCtx(() => [
      (appliedFiltersCount.value > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_k_btn, {
                model: "link",
                size: "sm",
                iconable: false,
                onClick: resetFilters
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_k_icon, {
                    name: "trash",
                    color: "error-70"
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "fs-13px fw-500 text-space-b-xd block q-ml-xs" }, " Clear All ", -1))
                ]),
                _: 1
              }),
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(appliedFiltersCount.value), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "Filters Applied", -1))
              ])
            ]),
            _createVNode(_component_k_divider, { size: "md" })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filters, (filterObj, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createVNode(LandingListFilterItem, {
              modelValue: filterRef.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filterRef).value = $event)),
              filter: filterObj
            }, null, 8, ["modelValue", "filter"])
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})